export default {
  en: {
    warranty_1: "is publishing the information contained in this document (\"Specification\") for purposes of scientific, experimental, and scholarly collaboration only.",
    warranty_2: "1EdTech makes no warranty or representation regarding the accuracy or completeness of the Specification.",
    warranty_3: "This material is provided on an \"As Is\" and \"As Available\" basis.",
    warranty_4: "The Specification is at all times subject to change and revision without notice.",
    warranty_5: "It is your sole responsibility to evaluate the usefulness, accuracy, and completeness of the Specification as it relates to you.",
    warranty_6: "1EdTech would appreciate receiving your comments and suggestions.",
    contact_url: "Please contact 1EdTech through our website at",
    contact_document: "Please refer to Document Name",
    contact_date: "Date"
  },
  es: {
    warranty_1: "publica la información contenida en este documento (\"Especificación\") solo con fines de colaboración científica, experimental y académica.",
    warranty_2: "1EdTech no ofrece ninguna garantía ni representación con respecto a la exactitud o integridad de la Especificación.",
    warranty_3: "Este material se proporciona tal cual.",
    warranty_4: "La especificación está sujeta en todo momento a cambios y revisiones sin previo aviso.",
    warranty_5: "Es su exclusiva responsabilidad evaluar la utilidad, precisión e integridad de la Especificación en lo que respecta a usted.",
    warranty_6: "1EdTech agradecería recibir sus comentarios y sugerencias.",
    contact_url: "Póngase en contacto con 1EdTech a través de nuestro sitio web en",
    contact_document: "Por favor mencione el Nombre del Documento",
    contact_date: "Fecha"
  },
  ca: {
    warranty_1: "publica la informació continguda en aquest document (\"Especificació\") només amb finalitats de col·laboració científica, experimental i acadèmica.",
    warranty_2: "1EdTech no ofereix cap garantia ni representació sobre l'exactitud o integritat de l'especificació.",
    warranty_3: "Este material se proporciona tal cual.",
    warranty_4: "L'Especificació està en tot moment subjecta a canvis i revisions sense previ avís.",
    warranty_5: "És la seva única responsabilitat avaluar la utilitat, exactitud i integritat de l'especificació tal com es relaciona amb vostè.",
    warranty_6: "1EdTech agrairia rebre els seus comentaris i suggeriments.",
    contact_url: "Contacteu amb 1EdTech a través de la nostra pàgina web",
    contact_document: "Si us plau, mencioni el Nom del Document",
    contact_date: "Data"
  }
};
